module.exports = __webpack_public_path__ + "img/Fulfillment.4d4f7f0b.svg";